import { Reveal, Overline } from "@/components/Reveal";

const chapters = [
  {
    no: "01",
    title: "The Beginning",
    text: "Elixz is a homegrown chocolate brand born in January 2026 in Pune. Our vision is to spread happiness through meaningful gifts. We started this journey so you can touch the hearts of your loved ones and bring genuine smiles.",
  },
  {
    no: "02",
    title: "The Craft",
    text: "Handmade in small batches with rich chocolate and delicious fillings, every personalized gift is crafted with love to truly stand out.",
  },
  {
    no: "03",
    title: "The Love",
    text: "150+ orders later, Elixz has become the gift people remember — trusted for weddings, corporate events and life's biggest days.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="story"
      className="relative mx-auto max-w-[1400px] px-6 py-28 md:px-12 md:py-40"
      data-testid="manifesto"
    >
      <Reveal>
        <Overline>The Elixz Story</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 max-w-4xl font-serif text-4xl font-light leading-[1.05] tracking-tight md:text-6xl">
          A homegrown chocolate brand that transforms ordinary gifting into an{" "}
          <span className="gold-gradient-text italic">emotional art form</span>.
        </h2>
      </Reveal>

      <div className="mt-20 grid gap-px overflow-hidden rounded-xl border border-[#311B4D] md:grid-cols-3">
        {chapters.map((c, i) => (
          <Reveal
            key={c.no}
            delay={i * 0.12}
            className="group relative bg-[#140823] p-10 transition-colors duration-500 hover:bg-[#1A0B2E] md:p-12"
          >
            <span className="font-serif text-6xl font-light text-[#311B4D] transition-colors duration-500 group-hover:text-[#D4AF37]/40">
              {c.no}
            </span>
            <h3 className="mt-6 font-serif text-2xl text-[#FDFBF7] md:text-3xl">
              {c.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-[#A894C2]">
              {c.text}
            </p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
